import React from "react";
import Foundation from "@microsoft/fast-components-foundation-react";
import { classNames } from "@microsoft/fast-web-utilities";
export const containerStyleSheet = {
    container: {
        display: "flex",
        width: "100vw",
        height: "100vh",
        "flex-direction": "column",
    },
};
/**
 * The Grid Container. This element wraps all other grid elements.
 */
export class Container extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            managedClasses: void 0,
        };
    }
    /**
     * Renders the Container markup
     */
    render() {
        return (React.createElement("div", Object.assign({}, this.unhandledProps(), { className: super.generateClassNames(classNames(this.props.managedClasses.container)) }), this.props.children));
    }
}
Container.displayName = "Container";
Container.defaultProps = {
    managedClasses: {},
};
